module.exports = __webpack_public_path__ + "static/media/jester_hat.9d95b837.png";